/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconForbid2 = createReactComponent("outline", "forbid-2", "IconForbid2", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M9 15l6 -6", "key": "svg-1" }]]);

export { IconForbid2 as default };
//# sourceMappingURL=IconForbid2.mjs.map
